import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { numericFormatter } from 'react-number-format';

import { Grid, Typography } from '@material-ui/core';
import { Row } from '../../Resources';
import ActivitiesRegistrationHeader from 'components/ActivitiesRegistrationDetails/ActivitiesRegistrationHeader';

import { convertToReal } from 'helpers/converters';
import { loadProductsFilters } from 'pages/Products/store/thunk';
import { loadProvisionalReceiptProductTables } from 'pages/ProvisionalReceiptProductConfig/store/thunk';

const hasKey = (register, key) => Object.keys(register || {}).includes(key);
const hasDynamicField = (register, key) => hasKey(register, 'dynamicFields') && Object.keys(register?.dynamicFields || {}).includes(key);

const formatDecimal = value => {
  if(value === null || value === undefined || value === '') {
    return '--';
  }

  return numericFormatter(value?.toString(), {
    thousandSeparator: '.',
    decimalSeparator: ',',
    decimalScale: 2,
    fixedDecimalScale: true
  });
}

function RegisterFields({
  register,
  productBrands,
  productTypes,
  suppliers,
  taxationOriginProducts,
  taxationSituationsProducts
}) {
  const getSupplierName = supplierId => {
    const supplier = suppliers?.find(item => +item?.id == +supplierId);

    return supplier?.supplierInfo?.fantasyName || supplier?.fantasyName || '--';
  }

  const getProductBrandName = productBrandId => {
    return productBrands?.find(brand => +brand?.id == +productBrandId)?.name || '--';
  }

  const getProductTypeName = productTypeId => {
    return productTypes?.find(type => +type?.id == +productTypeId)?.description || '--';
  }

  const getIcmsOriginName = icmsOriginId => {
    return taxationOriginProducts?.find(origin => origin?.value?.toString() == icmsOriginId?.toString())?.label || '--';
  }

  const getIcmsCstName = icmsCst => {
    return taxationSituationsProducts?.find(situation => situation?.value?.toString() == icmsCst?.toString())?.label || icmsCst || '--';
  }

  return(
    <>
      {hasKey(register, 'name') && (
        <Row>
          <Typography color='primary'>
            <b>Nome</b>
          </Typography>
          <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
            {register?.name || '--'}
          </Typography>
        </Row>
      )}
      {hasKey(register, 'barCode') && (
        <Row>
          <Typography color='primary'>
            <b>Código de barras</b>
          </Typography>
          <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
            {register?.barCode || '--'}
          </Typography>
        </Row>
      )}
      {hasKey(register, 'gtinEan') && (
        <Row>
          <Typography color='primary'>
            <b>GTIN/EAN</b>
          </Typography>
          <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
            {register?.gtinEan || '--'}
          </Typography>
        </Row>
      )}
      {hasKey(register, 'internalCode') && (
        <Row>
          <Typography color='primary'>
            <b>Código interno</b>
          </Typography>
          <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
            {register?.internalCode || '--'}
          </Typography>
        </Row>
      )}
      {hasKey(register, 'visible') && (
        <Row>
          <Typography color='primary'>
            <b>Status</b>
          </Typography>
          <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
            {+register?.visible == 1 ? 'Ativado' : 'Desativado'}
          </Typography>
        </Row>
      )}
      {hasKey(register, 'unitCost') && (
        <Row>
          <Typography color='primary'>
            <b>Custo unitário</b>
          </Typography>
          <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
            {convertToReal(register?.unitCost)}
          </Typography>
        </Row>
      )}
      {hasKey(register, 'salePrice') && (
        <Row>
          <Typography color='primary'>
            <b>Preço de venda</b>
          </Typography>
          <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
            {convertToReal(register?.salePrice)}
          </Typography>
        </Row>
      )}
      {hasKey(register, 'supplierId') && (
        <Row>
          <Typography color='primary'>
            <b>Fornecedor</b>
          </Typography>
          <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
            {getSupplierName(register?.supplierId)}
          </Typography>
        </Row>
      )}
      {hasKey(register, 'productTypeId') && (
        <Row>
          <Typography color='primary'>
            <b>Categoria</b>
          </Typography>
          <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
            {getProductTypeName(register?.productTypeId)}
          </Typography>
        </Row>
      )}
      {hasKey(register, 'productBrandId') && (
        <Row>
          <Typography color='primary'>
            <b>Marca</b>
          </Typography>
          <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
            {getProductBrandName(register?.productBrandId)}
          </Typography>
        </Row>
      )}
      {hasKey(register, 'minQuantityToSell') && (
        <Row>
          <Typography color='primary'>
            <b>Quantidade mínima para venda</b>
          </Typography>
          <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
            {register?.minQuantityToSell ?? '--'}
          </Typography>
        </Row>
      )}
      {hasKey(register, 'ncm') && (
        <Row>
          <Typography color='primary'>
            <b>NCM</b>
          </Typography>
          <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
            {register?.ncm || '--'}
          </Typography>
        </Row>
      )}
      {hasKey(register, 'cfop') && (
        <Row>
          <Typography color='primary'>
            <b>CFOP</b>
          </Typography>
          <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
            {register?.cfop || '--'}
          </Typography>
        </Row>
      )}
      {hasKey(register, 'icmsCst') && (
        <Row>
          <Typography color='primary'>
            <b>CST do ICMS</b>
          </Typography>
          <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
            {getIcmsCstName(register?.icmsCst)}
          </Typography>
        </Row>
      )}
      {hasKey(register, 'icmsOrigin') && (
        <Row>
          <Typography color='primary'>
            <b>Origem ICMS</b>
          </Typography>
          <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
            {register?.icmsOrigin || '--'}
          </Typography>
        </Row>
      )}
      {hasKey(register, 'icmsOriginId') && (
        <Row>
          <Typography color='primary'>
            <b>Origem ICMS (ID)</b>
          </Typography>
          <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
            {getIcmsOriginName(register?.icmsOriginId)}
          </Typography>
        </Row>
      )}
      {hasDynamicField(register, 'icmsModality') && (
        <Row>
          <Typography color='primary'>
            <b>Modalidade ICMS</b>
          </Typography>
          <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
            {register?.dynamicFields?.icmsModality || '--'}
          </Typography>
        </Row>
      )}
      {hasDynamicField(register, 'aliquota') && (
        <Row>
          <Typography color='primary'>
            <b>Alíquota</b>
          </Typography>
          <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
            {formatDecimal(register?.dynamicFields?.aliquota)}
          </Typography>
        </Row>
      )}
      {hasDynamicField(register, 'baseCalculoValor') && (
        <Row>
          <Typography color='primary'>
            <b>Valor da base de cálculo</b>
          </Typography>
          <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
            {formatDecimal(register?.dynamicFields?.baseCalculoValor)}
          </Typography>
        </Row>
      )}
      {hasDynamicField(register, 'percentualReducao') && (
        <Row>
          <Typography color='primary'>
            <b>Percentual de redução</b>
          </Typography>
          <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
            {formatDecimal(register?.dynamicFields?.percentualReducao)}
          </Typography>
        </Row>
      )}
      {hasDynamicField(register, 'creditoSimplesNacionalValor') && (
        <Row>
          <Typography color='primary'>
            <b>Crédito Simples Nacional (valor)</b>
          </Typography>
          <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
            {formatDecimal(register?.dynamicFields?.creditoSimplesNacionalValor)}
          </Typography>
        </Row>
      )}
      {hasDynamicField(register, 'creditoSimplesNacionalPercentual') && (
        <Row>
          <Typography color='primary'>
            <b>Crédito Simples Nacional (percentual)</b>
          </Typography>
          <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
            {formatDecimal(register?.dynamicFields?.creditoSimplesNacionalPercentual)}
          </Typography>
        </Row>
      )}
      {hasDynamicField(register, 'substituicaoTributariaAliquota') && (
        <Row>
          <Typography color='primary'>
            <b>Substituição tributária (alíquota)</b>
          </Typography>
          <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
            {formatDecimal(register?.dynamicFields?.substituicaoTributariaAliquota)}
          </Typography>
        </Row>
      )}
      {hasDynamicField(register, 'substituicaoTributariaBaseCalculoValor') && (
        <Row>
          <Typography color='primary'>
            <b>Substituição tributária (base de cálculo)</b>
          </Typography>
          <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
            {formatDecimal(register?.dynamicFields?.substituicaoTributariaBaseCalculoValor)}
          </Typography>
        </Row>
      )}
      {hasDynamicField(register, 'substituicaoTributariaModalidadeDeterminacao') && (
        <Row>
          <Typography color='primary'>
            <b>Substituição tributária (modalidade)</b>
          </Typography>
          <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
            {register?.dynamicFields?.substituicaoTributariaModalidadeDeterminacao || '--'}
          </Typography>
        </Row>
      )}
    </>
  );
}

export default function ProductSellUpdate({ activityData, lastRegister, newRegister }) {
  const dispatch = useDispatch();

  const { userId } = useSelector(state => state.profile);
  const { establishmentId } = useSelector(state => state.businessInfo);
  const { productBrands, productTypes, suppliers } = useSelector(state => state.products.filters);
  const {
    tables: {
      taxationOriginProducts,
      taxationSituationsProducts
    }
  } = useSelector(state => state.provisionalReceiptProductConfig);

  useEffect(() => {
    if(userId) {
      dispatch(loadProvisionalReceiptProductTables(userId));
    }

    if(userId && establishmentId) {
      dispatch(loadProductsFilters(userId, establishmentId));
    }
  }, [userId, establishmentId]);

  return(
    <Grid container>
      <Grid xs={12}>
        <ActivitiesRegistrationHeader
          activityData={activityData}
        />
        <Grid container style={{ marginTop: 10 }}>
          <Grid xs={12} style={{ padding: 5 }}>
            <Typography color='primary' style={{ marginBottom: 5, borderBottom: '1px solid #E4E7EA' }}>
              <b>Registro Anterior</b>
            </Typography>
            <Grid style={{ border: '1px solid #D7D7D7', borderRadius: 5, backgroundColor: '#FCFCFC', padding: 8, marginTop: 10 }}>
              <RegisterFields
                register={lastRegister}
                productBrands={productBrands}
                productTypes={productTypes}
                suppliers={suppliers}
                taxationOriginProducts={taxationOriginProducts}
                taxationSituationsProducts={taxationSituationsProducts}
              />
            </Grid>
          </Grid>
          <Grid xs={12} style={{ padding: 5 }}>
            <Typography color='primary' style={{ marginTop: 10, marginBottom: 5, borderBottom: '1px solid #E4E7EA' }}>
              <b>Novo Registro</b>
            </Typography>
            <Grid style={{ border: '1px solid #D7D7D7', borderRadius: 5, backgroundColor: '#FCFCFC', padding: 8, marginTop: 10 }}>
              <RegisterFields
                register={newRegister}
                productBrands={productBrands}
                productTypes={productTypes}
                suppliers={suppliers}
                taxationOriginProducts={taxationOriginProducts}
                taxationSituationsProducts={taxationSituationsProducts}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}